const initialState = {
  locationId: Number(localStorage.getItem('locationId')) || 0,
};

const LocationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_LOCATION':
      localStorage.setItem('locationId', action.payload);
      return { ...state, locationId: action.payload };
    default:
      return state;
  }
};

export default LocationReducer;
